/* src/components/project-tasks/project-tasks.component.scss */
:host {
  display: block;
}
/*# sourceMappingURL=project-tasks.component-HDT54Q6E.css.map */
